import React, {useEffect, useId, useState} from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import {useTheme} from "@mui/material/styles";

const Selected = ({
                      dir = 'rtl',
                      items=[],
                      defaultValue,
                      onChangeFunction,
                      sx = {},
                      value = 'value',
                      title = 'title',
                      ...props
                  }) => {

    const [selectedValue, setSelectedValue] = useState('')
    const handleChange = (e) => {
        let myValue = e.target.value
        if (myValue === null) return false;
        setSelectedValue(myValue)
        onChangeFunction(e)
    }

    const randId = useId();
    let them = useTheme();

    useEffect(() => {
        setSelectedValue(defaultValue)
    }, [defaultValue]);

    return (
        // <div dir={dir} style={{height: height, maxWidth: maxWidth, width: width, margin: margin}}
        //      onClick={handleOnClick}>
        <Select
            sx={{
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                ...sx
            }}
            value={selectedValue}
            onChange={(e) => handleChange(e)}
            displayEmpty
            inputProps={{'aria-label': 'Without label'}}
            {...props}
        >
            {items?.map((item, index) => <MenuItem sx={{direction: them.direction, ...item?.style}}
                                                   key={'item_' + randId + '_' + index}
                                                   value={item[value]}
                                                   onClick={() => item?.clickHandler ? item?.clickHandler() : undefined}
                >
                    {item[title]}
                </MenuItem>
            )}
        </Select>
        // </div>
    );
};

export default Selected;
